import { render, staticRenderFns } from "./tab-contracts.vue?vue&type=template&id=4514f182&scoped=true&"
import script from "./tab-contracts.vue?vue&type=script&lang=js&"
export * from "./tab-contracts.vue?vue&type=script&lang=js&"
import style0 from "./tab-contracts.vue?vue&type=style&index=0&id=4514f182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514f182",
  null
  
)

export default component.exports